import { Component, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { PermissaoEnum } from '@shared/enums/usuario/permissao.enum';
import { AuthService } from '@shared/services/apis/usuario/auth.service';
import { HeaderComponent } from '@shared/components/header/header.component';
import { EmptyListComponent } from '@shared/components/empty-list/empty-list.component';

@Component({
  selector: 'app-config-notas-fiscais',
  standalone: true,
  imports: [
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    HeaderComponent,
    EmptyListComponent,
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
  ],
  templateUrl: './config-notas-fiscais.component.html',
  styleUrls: ['./config-notas-fiscais.component.css'],
})
export class ConfigNotasFiscaisComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_NotasFiscais;

  // Item com `permissao` só aparece para quem a possui.
  public menuGroups: { title: string; items: { label: string; route: string; icon: string; permissao?: PermissaoEnum }[] }[] = [
    {
      title: 'Geral',
      items: [
        { label: 'Gerais', route: 'gerais', icon: 'tune', permissao: PermissaoEnum.Configuracoes_NotasFiscais_Visualizar },
        { label: 'Certificado', route: 'certificado', icon: 'verified_user' },
        { label: 'Emissores', route: 'emissor', icon: 'point_of_sale' },
      ],
    },
    {
      title: 'NF-e',
      items: [
        { label: 'NF-e', route: 'nfe', icon: 'settings', permissao: PermissaoEnum.Configuracoes_NotasFiscais_Visualizar },
        { label: 'Busca de NF-e na Sefaz', route: 'busca-nfe-sefaz', icon: 'cloud_sync' },
      ],
    },
    {
      title: 'NFC-e',
      items: [{ label: 'NFC-e', route: 'nfce', icon: 'receipt_long' }],
    },
    {
      title: 'Tributos',
      items: [
        { label: 'Natureza de operação', route: 'natureza-operacao', icon: 'rule_folder', permissao: PermissaoEnum.Configuracoes_NotasFiscais_Visualizar },
        { label: 'Tabela DIFAL', route: 'tabela-difal', icon: 'table_rows', permissao: PermissaoEnum.Configuracoes_NotasFiscais_Visualizar },
        { label: 'Tabela ANP', route: 'tabela-anp', icon: 'local_gas_station', permissao: PermissaoEnum.Configuracoes_NotasFiscais_Visualizar },
      ],
    },
  ];

  public filteredMenuGroups = [...this.menuGroups];
  public pesquisaControl = new FormControl('');

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    const permissoes = this.authService.getUserInfos()?.listaPermissoes ?? [];
    this.menuGroups = this.menuGroups.map(group => ({
      ...group,
      items: group.items.filter(item => !item.permissao || permissoes.includes(item.permissao)),
    }));

    this.pesquisaControl.valueChanges.subscribe(() => {
      this.filtrar();
    });
    this.filtrar();
  }

  public filtrar(): void {
    const termo = this.removeAcentos(this.pesquisaControl.value?.toLowerCase() || '');
    if (!termo) {
      this.filteredMenuGroups = this.menuGroups.filter(group => group.items.length > 0);
    } else {
      this.filteredMenuGroups = this.menuGroups
        .map(group => ({
          ...group,
          items: group.items.filter(item =>
            this.removeAcentos(item.label.toLowerCase()).includes(termo)
          ),
        }))
        .filter(group => group.items.length > 0);
    }
  }

  private removeAcentos(valor: string): string {
    return valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
